import { NgModule } from '@angular/core';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from './assets/en_devel.json';
import { CreateUserFormComponent } from './components/create-user/create-user-form.component';
import { AddUserDialogComponent } from './components/add-user/add-user-dialog.component';
import { CommonModule } from '@angular/common';
import { UserFullNamePipe } from './user-full-name.pipe';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { VaFilterModule } from '@vendasta/uikit';
import { MatInputModule } from '@angular/material/input';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AddUserDialogComponent, CreateUserFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    UserFullNamePipe,
    GalaxyButtonLoadingIndicatorModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    VaFilterModule,
    LexiconModule.forChild({
      componentName: 'common/users',
      baseTranslation: baseTranslation,
    }),
    MatInputModule,
    GalaxyInputModule,
  ],
  providers: [],
  exports: [AddUserDialogComponent, CreateUserFormComponent],
})
export class UsersModule {}
